declare namespace $ {

	type $mol_view_tree2_to_js_test_ex_array_union_foo_bar__1 = $mol_type_enforce<
		`a`
		,
		$mol_view_tree2_to_js_test_ex_klass_tuple_type
	>
	type $mol_view_tree2_to_js_test_ex_array_union_foo_bar__2 = $mol_type_enforce<
		`b`
		,
		$mol_view_tree2_to_js_test_ex_klass_tuple_type
	>
	export class $mol_view_tree2_to_js_test_ex_array_union_foo extends $mol_object {
		foo( ): string
		bar( ): readonly($mol_view_tree2_to_js_test_ex_klass_tuple_type)[]
	}
	
}

//# sourceMappingURL=array_union.view.tree.d.ts.map